module.exports = __webpack_public_path__ + "static/lova-sm-8694ccd726bec02826956f8fe149a350.jpg";